export const mottoRolesMixin = {
  data() {
    return {
      roleOptions: [
        'Loan Originator Phase 1',
        'Loan Originator Phase 2',
        'Operations Manager',
        'Office Staff',
        'Marketing Specialist',
        'In-house Processor',
        'LOA - Unlicensed',
        'LOA - Licensed',
      ],
      thirdPartyRoleOptions: ['Third-party Processor'],
      roleOptionsSubLabels: {
        'Loan Originator Phase 1':
          'Phase 1 LO (Unlicensed) receives MottoCenter, Outlook email, and wemlo training access.',
        'Loan Originator Phase 2':
          'Phase 2 LO (Licensed) access requires approval from Motto Support.  Once access has been granted they will receive additional access to wemlo production, a Website, MottoRep, and MottoSpark.',
        'Operations Manager':
          'Operations Manager has the same permissions as a Broker Owner. They can view the Personnel Management section in MottoCenter and has access to Outlook email, MottoSpark, MottoRep, and wemlo production.',
        'Office Staff': 'Office Staff has MottoCenter and Outlook email. MottoSpark access may be granted by request.',
        'Marketing Specialist':
          'Marketing Specialist user role has access to MottoCenter, Outlook email, MottoRep, and MottoSpark. They have the same admin permissions in MottoRep and MottoSpark as an Ops Manager.',
        'In-house Processor': 'In-house Processor has access to MottoCenter, Outlook email, and wemlo production.',
        LOA: 'LOA has access to MottoCenter, Outlook email, and wemlo production.',
        'LOA - Unlicensed': 'LOA - Unlicensed has access to MottoCenter, Outlook email, and wemlo production.',
        'LOA - Licensed': 'LOA - Licensed has access to MottoCenter, Outlook email, and wemlo production.',
        'Third-party Processor':
          'Third-party Processor has access to MottoCenter and MottoLearn LBS processing courses. <span><br></span> To grant a Third-party Processor access to wemlo LBS, log into your wemlo LBS brokerage account, click on My Account, select roles, and click the + processor button in the top right.',
      },
    }
  },
}
